<template>
	<Icon v-bind="$props">
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fal"
			data-icon="ellipsis-vertical"
			class="svg-inline--fa fa-ellipsis-vertical"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 128 512"
			:class="{ horizontal, vertical }"
		>
			<path
				class="light"
				fill="currentColor"
				d="M64 128c17.67 0 32-14.33 32-32s-14.33-32-32-32C46.33 64 32 78.33 32 96S46.33 128 64 128zM64 224C46.33 224 32 238.3 32 256s14.33 32 32 32c17.67 0 32-14.33 32-32S81.67 224 64 224zM64 384c-17.67 0-32 14.33-32 32s14.33 32 32 32c17.67 0 32-14.33 32-32S81.67 384 64 384z"
			></path>
			<path
				class="regular"
				fill="currentColor"
				d="M64 112c26.5 0 48-21.5 48-48S90.5 16 64 16S16 37.5 16 64S37.5 112 64 112zM64 400c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48S90.5 400 64 400zM64 208C37.5 208 16 229.5 16 256S37.5 304 64 304s48-21.5 48-48S90.5 208 64 208z"
			></path>
			<path
				class="solid"
				fill="currentColor"
				d="M128 64c0-35.39-28.62-64-64-64S0 28.61 0 64s28.62 64 64 64S128 99.39 128 64zM128 256c0-35.39-28.62-64-64-64S0 220.6 0 256s28.62 64 64 64S128 291.4 128 256zM128 448c0-35.39-28.62-64-64-64s-64 28.61-64 64s28.62 64 64 64S128 483.4 128 448z"
			></path>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'EllipsisIcon',
	components: { Icon },
	props: {
		...props,
		vertical: { type: Boolean, default: null },
		horizontal: { type: Boolean, default: null },
	},
}
</script>
<style lang="scss" scoped>
svg {
	&.horizontal {
		--rotate: 90deg;
	}
}
</style>
